import ScrollMagic from 'scrollmagic';
import 'ScrollMagicAddIndicators';

export default {
	init() {

		function GetInColumnsBox( container ) {

			var magicContainer = container.querySelectorAll('.box__subbox');

			var controller = new ScrollMagic.Controller();

			magicContainer.forEach( function( container, index ){

				new ScrollMagic.Scene({triggerElement: container, triggerHook: 0.99 })
					// trigger animation by adding a css class
					.setClassToggle(container, "load")
					// .addIndicators({name: index+" - ColumnsBox1"}) // add indicators (requires plugin)
					.addTo(controller);

			});
			
		}

		var container = document.querySelectorAll('.columnsBox1');

		if( container.length == 1 ) {

			GetInColumnsBox( container[0] );

		}
    
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
